<template>
  <transition :key="loading" name="fade" mode="out-in">
    <div
      v-if="loading"
      key="loading"
      class="shrink-0"
      :style="{
        height: height,
        width: width,
        margin: margin,
        borderRadius: borderRadius,
        style,
      }"
      :class="[preloaderClass, { dark: dark }]"
    >
      <span
        class="skeleton"
        :style="[shimmerStyles, { borderRadius: borderRadius }]"
        :class="shimmerClass"
      />
    </div>
    <template v-else>
      <slot />
    </template>
  </transition>
</template>

<script setup lang="ts">
import { computed } from "vue";
interface Props {
  loading?: boolean;
  height?: string | string[];
  width?: string | string[];
  margin?: string;
  line?: string | number;
  borderRadius?: string;
  preloaderClass?: string;
  circle?: boolean;
  dark?: boolean;
  style?: string;
  shimmerClass?: string;
}

const props = withDefaults(defineProps<Props>(), {
  line: 1,
  borderRadius: "4px",
  dark: false,
});

const shimmerStyles = computed(() => {
  return {
    "--width": props.width,
    "--height": props.height,
    "--border-radius": props.circle ? "50%" : props.borderRadius,
  };
});
</script>

<style scoped>
.skeleton {
  background-color: #eaeaea;
  background-image: linear-gradient(
    to right,
    rgb(227, 226, 226) 5.93%,
    rgb(178, 177, 177) 26.56%,
    rgb(234, 234, 234) 62.69%
  );
  width: 100%;
  height: 100%;
  border-radius: var(--border-radius);
  background-repeat: no-repeat;
  background-size: var(--width) var(--height);
  display: inline-block;
  position: relative;
  animation-duration: 10s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeholderShimmer;
  animation-timing-function: linear;
}
.dark .skeleton {
  background-color: rgba(114, 113, 114, 1);
  background: linear-gradient(90deg, #23242e 0%, #181921 49.48%, #23242e 100%);
}

@keyframes placeholderShimmer {
  0% {
    background-position: -468px 0;
  }

  100% {
    background-position: 468px 0;
  }
}

.skeleton-enter-active,
.skeleton-leave-active {
  transition: all 3s ease;
}

.skeleton-enter,
.skeleton-leave-to {
  opacity: 0;
}
</style>
